import { useState, useEffect } from 'react';
import useAuthUserId from '../../auth/hooks/useAuthUser';
import { userSdgAPI } from '../utils/API';
import { UserSDG } from 'sdgselection/types/SDG';
import sdgsData from "../data/sdgs.json";

const useUserSDG = () => {
  const [userSDGList, setUserSDGList] = useState<UserSDG[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const allSdgIds: number[] = sdgsData.map(sdg => sdg.id);

  const userId = useAuthUserId();

  const fetchUserSDG = async () => {
    if (userId) {
      try {
        setLoading(true);
        setError(null);
        const response = await userSdgAPI.getSdgsByUser(userId);
        setUserSDGList(response.userSdgs);
      } catch (err) {
        setError('Failed to fetch user SDGs');
      } finally {
        setLoading(false);
      }
    } else {
      setUserSDGList(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserSDG();
  }, [userId]);

  return { userSDGList, allSdgIds, loading, error };
};

export default useUserSDG;
